module.exports = __webpack_public_path__ + "media/images/Lock-0201ec51df92c39f1ea55bc1745390cd.svg";